import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, formValueSelector } from 'redux-form'
import { FORM_LISTADO_REPRESENTANTES } from '../../../config/forms'
import DatePicker from '../../LaridaeApp/datepicker/container/DatePicker'
import { Row, Col, Alert } from 'react-bootstrap'
import { COLORES } from '../../../config/colores'
import InfoIcon from '@material-ui/icons/Info'

function FormListadoRepresentantes (props) {
  const actualizarFechas = (fechaD, fechaH) => {
    const { change: formChange, actualizarListado } = props
    formChange('fechaD', moment(fechaD).format('DD-MM-YYYY'))
    formChange('fechaH', moment(fechaH).format('DD-MM-YYYY'))
    actualizarListado()
  }

  return (
    <>
      <Row style={{ display: 'flex', justifyContent: 'center' }}>
        <Col md={6}>
          <Col md={6} style={{ marginTop: '12px' }}>
            <DatePicker
              selectRange
              locale='es'
              onDateChange={actualizarFechas}
              titulo='Seleccione las fechas para la búsqueda'
              value='fechas'
            />
          </Col>
        </Col>
        <Col md={6}>
          {(props.fechaD && props.fechaH)
            ? <Alert style={{ backgroundColor: COLORES.grey.light, borderRadius: '22px 0 22px 22px' }}>
              <InfoIcon style={{ color: COLORES.grey.dark }} /> Importante: el resultado de la consulta se actualizará automáticamente cada 5 minutos.
            </Alert>
            : null }
        </Col>
      </Row>
    </>
  )
}

const selector = formValueSelector(FORM_LISTADO_REPRESENTANTES)

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_LISTADO_REPRESENTANTES)(state),
  fechaD: selector(state, 'fechaD'),
  fechaH: selector(state, 'fechaH')
})

const withRedux = connect(mapStateToProps)

const withReduxForm = reduxForm({
  form: FORM_LISTADO_REPRESENTANTES,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(FormListadoRepresentantes))
